// src/config/jira.js
// Calls our Azure Function proxy — avoids CORS and keeps the API token server-side

export async function fetchJiraAssets(serials) {
  // Fetch all CIE assets (staff devices) from Jira Assets via proxy
  const res = await fetch("/api/jira-assets");
  if (!res.ok) throw new Error(`Jira API error ${res.status}`);
  const data = await res.json();
  return data.assets || [];
}

export async function fetchJiraAssetBySerial(serial) {
  const res = await fetch(`/api/jira-asset-detail?serial=${encodeURIComponent(serial)}`);
  if (!res.ok) throw new Error(`Jira API error ${res.status}`);
  return res.json();
}

// Build a serial → Jira record lookup map from the bulk fetch
export function buildJiraMap(assets) {
  const map = {};
  for (const a of assets) {
    if (a.serial) map[a.serial.trim().toUpperCase()] = a;
  }
  return map;
}
